import { CatGrid } from '@blocks-react/components/Grid';
import { CatGridItem } from '@blocks-react/components/GridItem';
import { CatHeading } from '@blocks-react/components/Heading';
import { capitalizeText } from '../../Utils';
import { alpEquipmentProps, ServiceTranslationProps } from '../../types';
import styles from '../../serviceRecommendation.module.scss';
import { Conditional } from '../../../common';
import { PAGE_BREAKPOINTS } from '../../../../constants/commonConstants';
import { useBreakpoint } from '../../../../hooks';

type ServiceRecommendationEquipmentSectionProps = {
  ServiceModalTranslations: {
    equipmentTitle: ServiceTranslationProps['equipmentTitle'];
    dateTitle: ServiceTranslationProps['dateTitle'];
  };
  alpEquipment: alpEquipmentProps;
};

export const ServiceRecommendationEquipmentSection = ({
  ServiceModalTranslations,
  alpEquipment
}: ServiceRecommendationEquipmentSectionProps) => {
  const isSM = useBreakpoint(PAGE_BREAKPOINTS.MD);
  return (
    <Conditional test={!!isSM}>
      <CatGrid>
        <CatGridItem className="d-flex flex-column">
          <CatHeading
            level="h6"
            variant="label-lg"
            className={styles['service_recommendation_label']}
          >
            {ServiceModalTranslations.equipmentTitle}
          </CatHeading>
          <div className={styles['equipment_details']}>
            <img
              src={alpEquipment.imageURL}
              alt={alpEquipment.imageURL}
              width="120"
              height="90"
            />
            <div className={styles['equipment_details_model']}>
              <CatHeading variant="display-sm">{`${capitalizeText(
                alpEquipment.equipmentFamily
              )} ${alpEquipment.model}`}</CatHeading>
              <CatHeading variant="footnote-bold">
                {alpEquipment.serialNumber}
              </CatHeading>
            </div>
          </div>
        </CatGridItem>
      </CatGrid>
    </Conditional>
  );
};
